export default {
    name: "QuickActionsWidget",
    type: "HtmlWidget",
    description: "Shortcuts to common actions.",
    roles: ["appUser"],
    widget: {
        title: "Quick Actions",
        size: "small",
        html: `
            <div class="d-grid gap-2">
                <!-- UPDATED BUTTON: Uses 'emit' action -->
                <button class="btn btn-primary" data-action="emit" data-event="ui:show-project-modal">
                    <i class="bi bi-plus-lg me-2"></i> New Project
                </button>
                
                <button class="btn btn-outline-secondary" data-action="navigate" data-route="/user/assets">
                    <i class="bi bi-person-plus-fill me-2"></i> Create Character
                </button>
                <button class="btn btn-outline-secondary" data-action="navigate" data-route="/user/assets">
                    <i class="bi bi-image me-2"></i> Create Environment
                </button>
            </div>
        `
    }
};